import type { SnapshotFrom } from "xstate";
import type {
  prescriptionFlowMachine,
  PrescriptionFlowContext,
} from "./machine";

type PrescriptionFlowSnapshot = SnapshotFrom<typeof prescriptionFlowMachine>;

/**
 * Selectors for stable reads from the prescription flow state machine snapshot.
 *
 * @since 1.0.0
 * @example
 * ```ts
 * const selectRequestText = prescriptionFlowSelectors.requestText
 * ```
 */
export const prescriptionFlowSelectors = {
  context: (snapshot: PrescriptionFlowSnapshot): PrescriptionFlowContext =>
    snapshot.context,
  currentState: (snapshot: PrescriptionFlowSnapshot) => snapshot.value,
  patientId: (snapshot: PrescriptionFlowSnapshot) => snapshot.context.patientId,
  identification: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.identification,
  prescriptions: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.prescriptions,
  prescriptionsCount: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.prescriptionsCount,
  errorMessage: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.errorMessage,
  insuranceType: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.insuranceType,
  requestText: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.requestText,
  requestReason: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.requestReason,
  requestUrgency: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.requestUrgency,
  completionEmailRequested: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.completionEmailRequested,
  completionEmail: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.completionEmail,
  quarterlyEgkStatus: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.quarterlyEgkStatus,
  requestSubmitted: (snapshot: PrescriptionFlowSnapshot) =>
    snapshot.context.requestSubmitted,
};
